import { useEffect, useState, useCallback } from "react";
import apiManager from "../api/apiManager";
import API_ENDPOINTS from "../api/apiEndpoints";

export const useServiceFetching = (vehicleId, dealershipId, localizationFn) => {
  const [services, setServices] = useState({
    oem: { services: [], loading: false, error: null },
    recommended: { services: [], loading: false, error: null },
    optional: { services: [], loading: false, error: null },
  });
  const [motorServices, setMotorServices] = useState([]);
  const [dealerServices, setDealerServices] = useState([]);

  const fetchServices = useCallback(
    async (type) => {
      if (!vehicleId || !dealershipId) return;

      try {
        setServices((prev) => ({
          ...prev,
          [type]: { ...prev[type], loading: true, error: null },
        }));

        const endpoint =
          type === "oem"
            ? "OEM-services"
            : type === "recommended"
              ? "recommended-services"
              : "optional-services";

        const response = await apiManager.post(
          `${API_ENDPOINTS.SERVICES_CATEGORY}/${endpoint}`,
          {
            vehicleId: vehicleId,
            dealershipId: dealershipId,
          },
        );

        if (response.status === 200) {
          let serviceList = response.data.services || [];
          // Standardize image field to 'serviceImagePath' for recommended and optional
          if (type === "recommended" || type === "optional") {
            serviceList = serviceList.map((item) => ({
              ...item,
              serviceImagePath: item.serviceImagePath || item.ServiceImagePath || null,
            }));
          }
          setServices((prev) => ({
            ...prev,
            [type]: {
              services: serviceList,
              loading: false,
              error: null,
            },
          }));
        } else {
          setServices((prev) => ({
            ...prev,
            [type]: {
              services: [],
              loading: false,
              error: localizationFn("error_fetch_services"),
            },
          }));
        }
      } catch (err) {
        setServices((prev) => ({
          ...prev,
          [type]: {
            services: [],
            loading: false,
            error: err.message,
          },
        }));
      }
    },
    [vehicleId, dealershipId, localizationFn],
  );

  useEffect(() => {
    if (!vehicleId || !dealershipId) return;

    setServices({
      oem: { services: [], loading: true, error: null },
      recommended: { services: [], loading: true, error: null },
      optional: { services: [], loading: true, error: null },
    });

    ["oem", "recommended", "optional"].forEach((type) => fetchServices(type));
  }, [vehicleId, dealershipId, fetchServices]);

  return {
    services,
    motorServices,
    dealerServices,
    isLoading: Object.values(services).some((s) => s.loading),
  };
};

export default useServiceFetching;
